import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useFormikContext } from "formik";
import "./SelectButton";
import { useSelector } from "react-redux";
import { selectProfile } from "../../store/slices/profile-slice";
import Button from "react-bootstrap/Button";
import "./Profile.css";
import "react-toastify/dist/ReactToastify.css";
import { FaTrashAlt, FaEdit } from "react-icons/fa";
import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";
import { GeneralRadioGroupInput } from "../Custom-Forms/General-Radio-Group-Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faCheck } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import Card from "react-bootstrap/Card";
import prettyBytes from "pretty-bytes";
import {
    formateUploadDate,
    formatDateToInputFormat,
    formatDateToOutputFormat,
} from "./util/helpers.js";
import { FileUpload } from "../File-Upload/File-Upload";
import { FileUploadDelete } from "../File-Upload/File-Upload-Delete";
import { MdKeyboardReturn } from "react-icons/md";

export const AdditionalInfo = () => {
    const { values, setValues, errors } = useFormikContext();
    const profile = useSelector(selectProfile);

    const [areFelonyFieldsFilled, setAreFelonyFieldsFilled] = useState(false);
    const [areMisdemeanorFieldsFilled, setAreMisdemeanorFieldsFilled] =
        useState(false);
    const [arePhysicalFieldsFilled, setArePhysicalFieldsFilled] =
        useState(false);
    const [areRelationsFieldsFilled, setAreRelationsFieldsFilled] =
        useState(false);



    const [uploadAddInfo1, setUploadAddInfo1] = useState(false);
    const [uploadAddInfo2, setUploadAddInfo2] = useState(false);



    const checkFelonyFieldsFilled = (values) => {
        if (values.felony === "No") {
            return true;
        }

        if (values.felony === "") {
            return false;
        }

        return (
            values.felony && values.felonyDate && values.felonyReason
        );
    };
    const checkMisdemeanorFieldsFilled = (values) => {
        if (values.misdemeanor === "No") {
            return true;
        }

        if (values.misdemeanor === "") {
            return false;
        }

        return (
            values.misdemeanor &&
            values.misdemeanorDate &&
            values.misdemeanorReason
        );
    };
    const checkPhysicalFieldsFilled = (values) => {

        if (values.physical === "No") {
            return true;
        }

        if (values.physical === "") {
            return false;
        }

        if (values.physicalReason1 && !values.physicalName1 || !values.physicalReason1 && values.physicalName1) {
            return false;
        }

        if (values.physicalReason2 && !values.physicalName2 || !values.physicalReason2 && values.physicalName2) {
            return false;
        }

        if (values.physicalReason3 && !values.physicalName3 || !values.physicalReason3 && values.physicalName3) {
            return false;
        }
        return true;
    };
    const checkRelationsFieldsFilled = (values) => {

        if (values.relations === "No") {
            return true;
        }

        if (values.relations === "") {
            return false;
        }


        if (values.relationsName1 && !(values.relationsDepartment1 && values.relationsRelationship1) ||
            !values.relationsName1 && (values.relationsDepartment1 || values.relationsRelationship1)) {
            return false;
        }


        if (values.relationsName2 && !(values.relationsDepartment2 && values.relationsRelationship2) ||
            !values.relationsName2 && (values.relationsDepartment2 || values.relationsRelationship2)) {
            return false;
        }


        return true;
    };

    function areFieldsFilled(fieldNames, values) {
        return fieldNames.every((fieldName) => Boolean(values[fieldName]));
    }
    const areAdditionalFieldsFilled = (values) => {
        const fields = {
            felony: ["felonyDate", "felonyReason"],
            misdemeanor: ["misdemeanorDate", "misdemeanorReason"],
            physical: ["physicalName1", "physicalReason1"],
            relations: [
                "relationsName1",
                "relationsDepartment1",
                "relationsRelationship1",
            ],
        };

        for (const [attended, requiredFields] of Object.entries(fields)) {
            if (values[attended] === "") return false;
            if (
                values[attended] === "Yes" &&
                !areFieldsFilled(requiredFields, values)
            )
                return false;
        }

        return true;
    };


    useEffect(() => {

        setAreFelonyFieldsFilled(checkFelonyFieldsFilled(values));
    }, [
        values.felony,
        values.felonyDate,
        values.felonyReason,

    ]);



    useEffect(() => {

        setAreMisdemeanorFieldsFilled(checkMisdemeanorFieldsFilled(values));
    }, [
        values.misdemeanor,
        values.misdemeanorDate,
        values.misdemeanorReason,
    ]);



    useEffect(() => {

        setArePhysicalFieldsFilled(checkPhysicalFieldsFilled(values));
    }, [
        values.physical,
        values.physicalReason1,
        values.physicalName1,
        values.physicalReason2,
        values.physicalName2,
        values.physicalReason3,
        values.physicalName3
    ]);


    useEffect(() => {

        setAreRelationsFieldsFilled(checkRelationsFieldsFilled(values));
    }, [
        values.relations,
        values.relationsName1,
        values.relationsDepartment1,
        values.relationsRelationship1,
        values.relationsName2,
        values.relationsDepartment2,
        values.relationsRelationship2,
    ]);


    return (
        <>
            <Container className="container2 px-3">
                {areAdditionalFieldsFilled(values) && (
                    <>
                        <div
                            className="alert alert-success text-center success-msg animate__animated animate__fadeInUp mt-2 mb-0"
                            role="alert"
                        >
                            <h4 className="alert-heading fw-bold fs-5 fs-md-4">
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    style={{
                                        color: "cornflowerblue",
                                        fontSize: "1.5em",
                                    }}
                                    className="fa-fw fa-xs d-md-inline-block me-md-2 pt-1"
                                />
                            </h4>
                            Great! You have completed this step.
                        </div>
                    </>
                )}
                <Row className="d-flex justify-content-center mx-auto">
                    <Col className="col-auto pt-3">
                        <h3 className="header-font"><span>Additional Info</span></h3>
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center mx-auto bottom-border w-100">
                    {
                        <>
                            <Row className="d-flex justify-content-center mx-auto ">
                                <Col xs={"auto"}>
                                    <label className="info-label text-center px-0 mx-0 pt-1 w-auto ">
                                        Do you have a felony conviction?
                                    </label>
                                </Col>
                            </Row>
                            {values.felony === "" && (
                                <Row className="d-flex justify-content-center ">
                                    <p className="select-text w-auto fst-italic fw-bold text-center success-msg">
                                        Please Make a Selection
                                    </p>
                                </Row>
                            )}
                            <Row
                                className=" d-flex justify-content-center"
                                style={{ marginTop: "-12px" }}
                            >
                                <Col className="mt-3" xs={"auto"}>
                                    <GeneralRadioGroupInput
                                        name="felony"
                                        onChange={(e) => {
                                            setValues((prevValues) => ({
                                                ...prevValues,
                                                felony: e.target.value,
                                                ...(e.target.value === "No" && {
                                                    felonyDate: "",
                                                    felonyReason: "",
                                                }),
                                            }));
                                        }}
                                    />
                                </Col>
                            </Row>
                        </>
                    }

                    {values.felony === "Yes" &&
                      (
                            <>


                                <Card
                                    style={{ padding: 0 }}
                                    className="full-width-card"
                                >
                                    <Card.Header className="d-flex justify-content-center position-relative align-items-center bottom-border w-100 mx-auto">
                                        <h3 className="header-font"><span>Felony</span></h3>

                                        <Button
                                            className="transparent-btn me-2 position-absolute end-0"
                                            onClick={async () => {
                                                let result = await Swal.fire({
                                                    title: "Are you sure?",
                                                    text: "You won't be able to revert this!",
                                                    icon: "warning",
                                                    showCancelButton: true,
                                                    confirmButtonColor:
                                                        "#3085d6",
                                                    cancelButtonColor: "#d33",
                                                    confirmButtonText:
                                                        "Yes, delete it!",
                                                });

                                                if (result.isConfirmed) {
                                                    let valuesCopy = {
                                                        ...values,
                                                    };
                                                    valuesCopy.felonyDate = "";
                                                    valuesCopy.felonyReason =
                                                        "";
                                                    valuesCopy.felony = "No";

                                                    setValues(valuesCopy);
                                                }
                                            }}
                                        >
                                            <FaTrashAlt
                                                className="icon trash-icon"
                                                style={{ fontSize: "20px" }}
                                            />
                                        </Button>
                                    </Card.Header>
                                    <Row className="d-flex justify-content-center bottom-border w-100 mx-auto ">
                                        <Col xs={10} lg={7}>
                                            <label
                                                className="info-label text-center pt-1"
                                                style={{
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                Felony Reason
                                            </label>
                                            <GeneralTextAreaField
                                                className="form-control"
                                                component="textarea"
                                                rows="2"
                                                name="felonyReason"
                                                maxLength={200}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="d-flex justify-content-center w-100 mx-auto mb-5">
                                        <Col xs={10} lg={7}>
                                            <label
                                                className="info-label text-center pt-1"
                                                style={{
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                Felony Date
                                            </label>
                                            <GeneralTextAreaField
                                                className="form-control"
                                                type="date"
                                                name="felonyDate"
                                                value={formatDateToInputFormat(
                                                    values.felonyDate,
                                                )}
                                                placeholder="MM/DD/YYYY"
                                            />
                                        </Col>
                                    </Row>

                                </Card>
                            </>
                        )}
                </Row>

                <Row className="d-flex justify-content-center mx-auto bottom-border w-100">
                    {
                        <>
                            <Row className="d-flex justify-content-center  ">
                                <Col xs={"auto"} className="mx-0">
                                    <label className="info-label text-center px-0 mx-0 pt-1 w-auto ">
                                        Do you have a misdemeanor conviction?
                                    </label>
                                </Col>
                            </Row>
                            {values.misdemeanor === "" && (
                                <Row className="d-flex justify-content-center ">
                                    <p className="select-text w-auto fst-italic fw-bold text-center success-msg">
                                        Please Make a Selection
                                    </p>
                                </Row>
                            )}
                            <Row
                                className=" d-flex justify-content-center"
                                style={{ marginTop: "-12px" }}
                            >
                                <Col className="mt-3" xs={"auto"}>
                                    <GeneralRadioGroupInput
                                        name="misdemeanor"
                                        onChange={(e) => {
                                            setValues((prevValues) => ({
                                                ...prevValues,
                                                misdemeanor: e.target.value,
                                                ...(e.target.value === "No" && {
                                                    misdemeanorDate: "",
                                                    misdemeanorReason: "",
                                                }),
                                            }));
                                        }}
                                    />
                                </Col>
                            </Row>
                        </>
                    }

                    {values.misdemeanor === "Yes" &&
                       (
                            <>

                                <Card
                                    style={{ padding: 0 }}
                                    className="full-width-card"
                                >
                                    <Card.Header className="d-flex justify-content-center position-relative align-items-center bottom-border w-100 mx-auto">
                                        <h3 className="header-font"><span>Misdemeanor</span></h3>

                                        <Button
                                            className="transparent-btn me-2 position-absolute end-0"
                                            onClick={async () => {
                                                let result = await Swal.fire({
                                                    title: "Are you sure?",
                                                    text: "You won't be able to revert this!",
                                                    icon: "warning",
                                                    showCancelButton: true,
                                                    confirmButtonColor:
                                                        "#3085d6",
                                                    cancelButtonColor: "#d33",
                                                    confirmButtonText:
                                                        "Yes, delete it!",
                                                });

                                                if (result.isConfirmed) {
                                                    let valuesCopy = {
                                                        ...values,
                                                    };
                                                    valuesCopy.misdemeanorDate =
                                                        "";
                                                    valuesCopy.misdemeanorReason =
                                                        "";
                                                    valuesCopy.misdemeanor =
                                                        "No";

                                                    setValues(valuesCopy);
                                                }
                                            }}
                                        >
                                            <FaTrashAlt
                                                className="icon trash-icon"
                                                style={{ fontSize: "20px" }}
                                            />
                                        </Button>
                                    </Card.Header>
                                    <Row className="d-flex justify-content-center bottom-border w-100 mx-auto ">
                                        <Col xs={10} lg={7}>
                                            <label
                                                className="info-label text-center pt-1 "
                                                style={{
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                Misdemeanor Reason
                                            </label>
                                            <GeneralTextAreaField
                                                className="form-control"
                                                component="textarea"
                                                rows="2"
                                                name="misdemeanorReason"
                                                maxLength={200}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="d-flex justify-content-center w-100 mx-auto mb-5">
                                        <Col xs={10} lg={7}>
                                            <label
                                                className="info-label text-center pt-1 "
                                                style={{
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                Misdemeanor Date
                                            </label>
                                            <GeneralTextAreaField
                                                className="form-control"
                                                type="date"
                                                name="misdemeanorDate"
                                                value={formatDateToInputFormat(
                                                    values.misdemeanorDate,
                                                )}
                                                placeholder="MM/DD/YYYY"
                                            />
                                        </Col>
                                    </Row>

                                </Card>
                            </>
                        )}
                </Row>

                <Row className="d-flex justify-content-center mx-auto bottom-border w-100">
                    {
                        <>
                            <Row className="d-flex justify-content-center  ">
                                <Col xs={"auto"} className="mx-0">
                                    <label className="info-label text-center px-0 mx-0 pt-1 w-auto">
                                        Do you have any known physical
                                        conditions that we should be aware of?
                                    </label>
                                </Col>
                            </Row>
                            {values.physical === "" && (
                                <Row className="d-flex justify-content-center ">
                                    <p className="select-text w-auto fst-italic fw-bold text-center success-msg">
                                        Please Make a Selection
                                    </p>
                                </Row>
                            )}
                            <Row
                                className=" d-flex justify-content-center"
                                style={{ marginTop: "-12px" }}
                            >
                                <Col className="mt-3" xs={"auto"}>
                                    <GeneralRadioGroupInput
                                        name="physical"
                                        onChange={(e) => {
                                            setValues((prevValues) => ({
                                                ...prevValues,
                                                physical: e.target.value,
                                                ...(e.target.value === "No" && {
                                                    physicalName1: "",
                                                    physicalReason1: "",
                                                    physicalName2: "",
                                                    physicalReason2: "",
                                                    physicalName3: "",
                                                    physicalReason3: "",
                                                }),
                                            }));
                                        }}
                                    />
                                </Col>
                            </Row>
                        </>
                    }

                    {values.physical === "Yes" &&
                     (
                            <>


                                <Card
                                    style={{ padding: 0 }}
                                    className="full-width-card"
                                >
                                    <Card.Header className="d-flex justify-content-center position-relative align-items-center bottom-border w-100 mx-auto">
                                        <h3 className="header-font"><span>Physical Condition</span></h3>

                                        <Button
                                            className="transparent-btn me-2 position-absolute end-0"
                                            onClick={async () => {
                                                let result = await Swal.fire({
                                                    title: "Are you sure?",
                                                    text: "You won't be able to revert this!",
                                                    icon: "warning",
                                                    showCancelButton: true,
                                                    confirmButtonColor:
                                                        "#3085d6",
                                                    cancelButtonColor: "#d33",
                                                    confirmButtonText:
                                                        "Yes, delete it!",
                                                });

                                                if (result.isConfirmed) {
                                                    let valuesCopy = {
                                                        ...values,
                                                    };
                                                    valuesCopy.physicalName1 =
                                                        "";
                                                    valuesCopy.physicalReason1 =
                                                        "";
                                                    valuesCopy.physicalName2 =
                                                        "";
                                                    valuesCopy.physicalReason2 =
                                                        "";
                                                    valuesCopy.physicalName3 =
                                                        "";
                                                    valuesCopy.physicalReason3 =
                                                        "";
                                                    valuesCopy.physical = "No";

                                                    setValues(valuesCopy);
                                                }
                                            }}
                                        >
                                            <FaTrashAlt
                                                className="icon trash-icon"
                                                style={{ fontSize: "20px" }}
                                            />
                                        </Button>
                                    </Card.Header>
                                    <Row className="d-flex justify-content-center bottom-border w-100 mx-auto ">
                                        <Row className="d-flex justify-content-center  w-100 mx-auto ">
                                            <Col xs={10} lg={7}>
                                                <label
                                                    className="info-label text-center pt-1 "
                                                    style={{
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    Physical Condition
                                                </label>
                                                <GeneralTextAreaField
                                                    className="form-control"
                                                    component="textarea"
                                                    rows="2"
                                                    name="physicalName1"
                                                    maxLength={250}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="d-flex justify-content-center w-100 mx-auto ">
                                            <Col xs={10} lg={7}>
                                                <label
                                                    className="info-label text-center pt-1 "
                                                    style={{
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    Condition Details
                                                </label>
                                                <GeneralTextAreaField
                                                    className="form-control"
                                                    component="textarea"
                                                    rows="2"
                                                    name="physicalReason1"
                                                    maxLength={250}
                                                />
                                            </Col>
                                        </Row>
                                    </Row>
                                    <Row className="d-flex justify-content-center bottom-border w-100 mx-auto ">
                                        <Row className="d-flex justify-content-center  w-100 mx-auto ">
                                            <Col xs={10} lg={7}>
                                                <label
                                                    className="info-label text-center pt-1 "
                                                    style={{
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    Physical Condition 2
                                                </label>
                                                <GeneralTextAreaField
                                                    className="form-control"
                                                    placeholder="Optional"
                                                    component="textarea"
                                                    rows="2"
                                                    name="physicalName2"
                                                    maxLength={250}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="d-flex justify-content-center w-100 mx-auto ">
                                            <Col xs={10} lg={7}>
                                                <label
                                                    className="info-label text-center pt-1 "
                                                    style={{
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    Condition Details 2
                                                </label>
                                                <GeneralTextAreaField
                                                    className="form-control"
                                                    placeholder="Optional"
                                                    component="textarea"
                                                    rows="2"
                                                    name="physicalReason2"
                                                    maxLength={250}
                                                />
                                            </Col>
                                        </Row>
                                    </Row>
                                    <Row className="d-flex justify-content-center  w-100 mx-auto mb-4">
                                        <Row className="d-flex justify-content-center  w-100 mx-auto ">
                                            <Col xs={10} lg={7}>
                                                <label
                                                    className="info-label text-center pt-1 "
                                                    style={{
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    Physical Condition 3
                                                </label>
                                                <GeneralTextAreaField
                                                    className="form-control"
                                                    placeholder="Optional"
                                                    component="textarea"
                                                    rows="2"
                                                    name="physicalName3"
                                                    maxLength={250}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="d-flex justify-content-center w-100 mx-auto ">
                                            <Col xs={10} lg={7}>
                                                <label
                                                    className="info-label text-center pt-1 "
                                                    style={{
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    Condition Details 3
                                                </label>
                                                <GeneralTextAreaField
                                                    className="form-control"
                                                    placeholder="Optional"
                                                    component="textarea"
                                                    rows="2"
                                                    name="physicalReason3"
                                                    maxLength={250}
                                                />
                                            </Col>
                                        </Row>
                                    </Row>

                                </Card>
                            </>
                        )}
                </Row>

                {
                    <>
                        <Row className="d-flex justify-content-center mx-auto w-100">
                            <Col xs={"auto"} className="mx-0">
                                <label className="info-label text-center px-0 mx-0 pt-1 w-auto">
                                    Are you related to anyone employed with the
                                    Navajo Nation?
                                </label>
                            </Col>
                        </Row>
                        {values.relations === "" && (
                            <Row className="d-flex justify-content-center ">
                                <p className="select-text w-auto fst-italic fw-bold text-center success-msg ">
                                    Please Make a Selection
                                </p>
                            </Row>
                        )}
                        <Row
                            className=" d-flex justify-content-center"
                            style={{ marginTop: "-12px" }}
                        >
                            <Col className="mt-3" xs={"auto"}>
                                <GeneralRadioGroupInput
                                    name="relations"
                                    onChange={(e) => {
                                        setValues((prevValues) => ({
                                            ...prevValues,
                                            relations: e.target.value,
                                            ...(e.target.value === "No" && {
                                                relationsName1: "",
                                                relationsDepartment1: "",
                                                relationsRelationship1: "",
                                                relationsName2: "",
                                                relationsDepartment2: "",
                                                relationsRelationship2: "",
                                            }),
                                        }));
                                    }}
                                />
                            </Col>
                        </Row>
                    </>
                }

                {values.relations === "Yes" &&
                    (
                        <>
                            <Card
                                style={{ padding: 0 }}
                                className="full-width-card"
                            >


                            </Card>

                            <Card
                                style={{ padding: 0 }}
                                className="full-width-card"
                            >
                                <Card.Header className="d-flex justify-content-center position-relative align-items-center bottom-border w-100 mx-auto">
                                    <h3 className="header-font"><span>Related Employee</span></h3>

                                    <Button
                                        className="transparent-btn me-2 position-absolute end-0"
                                        onClick={async () => {
                                            let result = await Swal.fire({
                                                title: "Are you sure?",
                                                text: "You won't be able to revert this!",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "#3085d6",
                                                cancelButtonColor: "#d33",
                                                confirmButtonText:
                                                    "Yes, delete it!",
                                            });

                                            if (result.isConfirmed) {
                                                let valuesCopy = {
                                                    ...values,
                                                };
                                                valuesCopy.relationsRelationship1 =
                                                    "";
                                                valuesCopy.relationsDepartment1 =
                                                    "";
                                                valuesCopy.relationsName1 = "";
                                                valuesCopy.relationsName2 = "";
                                                valuesCopy.relationsRelationship2 = "";
                                                valuesCopy.relationsDepartment2 = "";
                                                valuesCopy.relations = "No";

                                                setValues(valuesCopy);
                                            }
                                        }}
                                    >
                                        <FaTrashAlt
                                            className="icon trash-icon"
                                            style={{ fontSize: "20px" }}
                                        />
                                    </Button>
                                </Card.Header>
                                <Row className="d-flex justify-content-center w-100 mx-auto ">
                                    <Col xs={10} lg={7}>
                                        <label className="info-label text-center pt-1 ">
                                            Name of Related Employee
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="relationsName1"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto ">
                                    <Col xs={10} lg={7}>
                                        <label className="info-label text-center pt-1 ">
                                            Department of Related Employee
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="relationsDepartment1"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center bottom-border w-100 mx-auto ">
                                    <Col xs={10} lg={7}>
                                        <label className="info-label text-center pt-1 ">
                                            Relationship with Related
                                            Employee
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="relationsRelationship1"
                                        />
                                    </Col>
                                </Row>

                                <Row className="d-flex justify-content-center w-100 mx-auto ">
                                    <Col xs={10} lg={7}>
                                        <label className="info-label text-center pt-1 ">
                                            Name of Related Employee 2
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="relationsName2"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto ">
                                    <Col xs={10} lg={7}>
                                        <label className="info-label text-center pt-1 ">
                                            Department of Related Employee 2
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="relationsDepartment2"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mb-4">
                                    <Col xs={10} lg={7}>
                                        <label className="info-label text-center pt-1 ">
                                            Relationship with Related
                                            Employee 2
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="relationsRelationship2"
                                        />
                                    </Col>
                                </Row>
                            </Card>
                        </>
                    )}

                <Row className="mx-auto bg-body-secondary rounded-5 py-4 px-4 mb-4 mt-4">
                    <Col>
                        <h3 className="d-inline-block opacity-75 mt-3 border-bottom border-warning border-5 title-font mb-2">
                            Support Documents
                        </h3>
                        <h5 className="fw-bold opacity-75 mb-4 lh-base">
                            <p>
                                Information such as Work History or Education Details will need to be entered by the user, they will not be gathered from your supporting documents.
                            </p>
                            <strong className="text-danger">
                                We request that you enter the required information on your application rather than submitting a resume.
                            </strong>
                        </h5>
                    </Col>
                </Row>

                <Row className="d-flex justify-content-center w-100 mx-auto">
                    <Row className="bottom-border w-100">
                        <Card.Header
                            style={{
                                display: "flex",

                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <h4 className="border-bottom border-warning border-5">
                                Upload Resume
                            </h4>
                        </Card.Header>
                        <Card.Body>
                            {profile.Additional_Info_Field_1In === "Yes" && (
                                <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                    <Col className="py-3">
                                        <Row>
                                            <Col className="text-center">
                                                <h5 className="border-bottom border-warning border-5">
                                                    {" "}
                                                    Current Resume on File:
                                                </h5>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <b>File Name:</b>{" "}
                                                {
                                                    profile.Additional_Info_Field_1_OriginalName
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <b>Upload Date:</b>{" "}
                                                {formateUploadDate(
                                                    profile.Additional_Info_Field_1_UploadDate,
                                                )}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <b>Size:</b>{" "}
                                                {profile.Additional_Info_Field_1_FileSize
                                                    ? prettyBytes(
                                                        parseInt(
                                                            profile.Additional_Info_Field_1_FileSize,
                                                        ),
                                                    )
                                                    : ""}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <FileUploadDelete
                                                containerName={
                                                    "Additional_Info_Field_1"
                                                }
                                                fileName={
                                                    profile.Additional_Info_Field_1_OriginalName
                                                }
                                            />
                                        </Row>
                                    </Col>
                                </Row>
                            )}
                        </Card.Body>
                        {uploadAddInfo1 && (
                            <FileUpload
                                containerName={"Additional_Info_Field_1"}
                            />
                        )}
                        {profile.Additional_Info_Field_1In === "No" &&
                            !uploadAddInfo1 && (
                                <Col className="d-flex justify-content-center mb-4">
                                    <Button
                                        variant="primary"
                                        className={
                                            uploadAddInfo1 ? "btn-danger" : ""
                                        }
                                        onClick={() =>
                                            setUploadAddInfo1(!uploadAddInfo1)
                                        }
                                    >
                                        {uploadAddInfo1
                                            ? "Cancel"
                                            : "Upload New Resume"}
                                    </Button>
                                </Col>
                            )}
                    </Row>

                    <Row className="bottom-border w-100">
                        <Card.Header
                            style={{
                                display: "flex",

                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <h4 className="border-bottom border-warning border-5">
                                Upload Cover Letter
                            </h4>
                        </Card.Header>
                        <Card.Body>
                            {profile.Additional_Info_Field_2In === "Yes" && (
                                <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                    <Col className="py-3">
                                        <Row>
                                            <Col className="text-center">
                                                <h5 className="border-bottom border-warning border-5">
                                                    {" "}
                                                    Current Cover Letter on File:
                                                </h5>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <b>File Name:</b>{" "}
                                                {
                                                    profile.Additional_Info_Field_2_OriginalName
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <b>Upload Date:</b>{" "}
                                                {formateUploadDate(
                                                    profile.Additional_Info_Field_2_UploadDate,
                                                )}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <b>Size:</b>{" "}
                                                {profile.Additional_Info_Field_2_FileSize
                                                    ? prettyBytes(
                                                        parseInt(
                                                            profile.Additional_Info_Field_2_FileSize,
                                                        ),
                                                    )
                                                    : ""}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <FileUploadDelete
                                                containerName={
                                                    "Additional_Info_Field_2"
                                                }
                                                fileName={
                                                    profile.Additional_Info_Field_2_OriginalName
                                                }
                                            />
                                        </Row>
                                    </Col>
                                </Row>
                            )}
                        </Card.Body>
                        {uploadAddInfo2 && (
                            <FileUpload
                                containerName={"Additional_Info_Field_2"}
                            />
                        )}
                        {profile.Additional_Info_Field_2In === "No" &&
                            !uploadAddInfo2 && (
                                <Col className="d-flex justify-content-center mb-4">
                                    <Button
                                        variant="primary"
                                        className={
                                            uploadAddInfo2 ? "btn-danger" : ""
                                        }
                                        onClick={() =>
                                            setUploadAddInfo2(!uploadAddInfo2)
                                        }
                                    >
                                        {uploadAddInfo2
                                            ? "Cancel"
                                            : "Upload New Cover Letter"}
                                    </Button>
                                </Col>
                            )}
                    </Row>
                </Row>
            </Container>
        </>
    );
};
